import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import awsRegions from "aws-regions";

import {
  postFeatureConfiguration,
} from "../../../../store/featureConfiguration/featureConfigurationSlice";

const BucketPolicyModal = (props) => {
  console.log("🚀 ~ BucketPolicyModal ~ props:", props)
  const [role, setRole] = useState("");
  const [bucketName, setBucketName] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [processingMode, setProcessingMode] = useState("");
  const [selectedMemberAccounts, setSelectedMemberAccounts] = useState([]);
  const [errors, setErrors] = useState({});
  const { accountNumber, externalId, iamrole, is_master } = props.editAccount;
  const { addOnsName } = props;
  const { accounts } = props;
  const setNotificationSent = props.setNotificationSent;

  const validateRole = (value) => {
    if (!value) {
      return "Role is required";
    } else if (!/^arn:aws:iam::[0-9]{12}:role/.test(value)) {
      return "IAM Role must be in proper format";
    }
    return "";
  };

  const validateAccountNumber = () => {
    const value = accountNumber;
    if (!value) {
      return "Account number is required";
    } else if (!/^[0-9]+$/.test(value) || value.length !== 12) {
      return "Account number must be exactly 12 digits and only numbers";
    }
    return "";
  };

  const validateBucketName = (value) => {
    if (!value) {
      return "Bucket name is required";
    } else if (!/^arn:aws:s3:::[a-z0-9]([a-z0-9.-]{1,61}[a-z0-9])?$/.test(value)) {
      return "S3 bucket name must be in proper format";
    }
    return "";
  };

  const validateSelectedRegion = (value) => {
    if (!value) {
      return "AWS Region is required";
    }
    return "";
  };

  const validateProcessingMode = (value) => {
    if (addOnsName === "Cost Insight" && is_master && !value) {
      return "Processing mode is required";
    }
    return "";
  };

  const validateMemberAccounts = (value) => {
    // No validation required - user can leave blank
    return "";
  };

  const handleRoleChange = (e) => {
    const value = e.target.value;
    setRole(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      role: validateRole(value),
    }));
  };

  const handleBucketNameChange = (e) => {
    const value = e.target.value;
    setBucketName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      bucketName: validateBucketName(value),
    }));
  };

  const handleRegionChange = (e) => {
    const value = e.target.value;
    setSelectedRegion(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedRegion: validateSelectedRegion(value),
    }));
  };

  const handleProcessingModeChange = (e) => {
    const value = e.target.value;
    setProcessingMode(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      processingMode: validateProcessingMode(value),
    }));
  };

  const handleMemberAccountsChange = (event) => {
    const value = event.target.value;
    setSelectedMemberAccounts(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      memberAccounts: validateMemberAccounts(value),
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setNotificationSent(false);

    const roleError = validateRole(role);
    const accountNumberError = validateAccountNumber();
    const bucketNameError = validateBucketName(bucketName);
    const selectedRegionError = validateSelectedRegion(selectedRegion);
    const processingModeError = validateProcessingMode(processingMode);
    const memberAccountsError = validateMemberAccounts(selectedMemberAccounts);

    if (!roleError && !accountNumberError && !bucketNameError && !selectedRegionError && !processingModeError && !memberAccountsError) {
      const featureConfigurationRequest = {
        role: role,
        accountNumber: accountNumber,
        bucketName: bucketName,
        readOnlyRole: iamrole,
        selectedRegion: selectedRegion,
        module: addOnsName,
        externalId: externalId,
      };

      // Add processingMode only for Cost Insight and Master accounts
      if (addOnsName === "Cost Insight" && is_master) {
        featureConfigurationRequest.processingMode = processingMode;
      }

      // Add memberAccountNumbers only for Event Insight and Master accounts
      if (addOnsName === "Event Insight" && is_master) {
        featureConfigurationRequest.memberAccountNumbers = selectedMemberAccounts.join(',');
      }

      console.log("featureConfigurationRequest = ", featureConfigurationRequest);
      props.postFeatureConfiguration(featureConfigurationRequest);
    } else {
      setErrors({
        role: roleError,
        accountNumber: accountNumberError,
        bucketName: bucketNameError,
        selectedRegion: selectedRegionError,
        processingMode: processingModeError,
        memberAccounts: memberAccountsError,
      });
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={props.isOpen} backdrop="static" centered style={{ maxWidth: "700px" }}>
        <ModalHeader toggle={props.closeModal}>
          Verify Bucket Policy
        </ModalHeader>
        <ModalBody>
          Verify Bucket Policy for Additional Addons: {addOnsName === "Event Insight" ? "Cloud Event" : addOnsName === "Cost Insight" ? "FinOps" : addOnsName} for Account Number: {accountNumber}

          <Box>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Role ARN*"
                size="small"
                value={role}
                onChange={handleRoleChange}
                error={!!errors.role}
                helperText={errors.role}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Account Number*"
                size="small"
                value={accountNumber}
                disabled
                error={!!errors.accountNumber}
                helperText={errors.accountNumber}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth margin="normal">
              <TextField
                label="S3 Bucket ARN*"
                size="small"
                value={bucketName}
                onChange={handleBucketNameChange}
                error={!!errors.bucketName}
                helperText={errors.bucketName}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth margin="normal" error={!!errors.selectedRegion}>
              <InputLabel>S3 AWS Region*</InputLabel>
              <Select
                value={selectedRegion}
                onChange={handleRegionChange}
                label="S3 AWS Region*"
                size="small"
              >
                <MenuItem value="">
                  <em>Select AWS Region*</em>
                </MenuItem>
                {awsRegions.list().map((region) => (
                  <MenuItem key={region.code} value={region.code}>
                    {region.name} — {region.code}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.selectedRegion}</FormHelperText>
            </FormControl>
            
            {/* Processing Mode Dropdown - Only for Cost Insight and Master accounts */}
            {addOnsName === "Cost Insight" && is_master && (
              <FormControl fullWidth margin="normal" error={!!errors.processingMode}>
                <InputLabel>Processing Mode*</InputLabel>
                <Select
                  value={processingMode}
                  onChange={handleProcessingModeChange}
                  label="Processing*"
                  size="small"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        minWidth: 320,
                      },
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select Processing Mode*</em>
                  </MenuItem>
                  <MenuItem value="MASTER_AND_ALL_MEMBERS">
                    All Organization accounts
                  </MenuItem>
                  <MenuItem value="MASTER_AND_ONBOARDED_MEMBERS_ONLY">
                    Onboarded Accounts Only
                  </MenuItem>
                </Select>
                <FormHelperText>{errors.processingMode}</FormHelperText>
              </FormControl>
            )}

            {/* Member Accounts Dropdown - Only for Event Insight and Master accounts */}
            {addOnsName === "Event Insight" && is_master && (() => {
              const validAccounts = accounts?.filter(acc => {
                // Filter accounts that are not master, have Event Insight disabled, and are not INIT accounts
                const isNotMaster = acc.accountNumber !== accountNumber;
                const eventInsightAddon = acc.subscription?.addons?.find(addon => addon.name === "Event Insight");
                const isEventInsightDisabled = !eventInsightAddon || eventInsightAddon.enabled === false;
                const isNotInit = !acc.accountNumber.startsWith("INIT");
                return isNotMaster && isEventInsightDisabled && isNotInit;
              }) || [];

              // Only show dropdown if there are valid accounts (more than 1 including master)
              return validAccounts.length > 0 ? (
                <FormControl fullWidth margin="normal" error={!!errors.memberAccounts}>
                  <InputLabel>Member Accounts</InputLabel>
                  <Select
                    multiple
                    value={selectedMemberAccounts}
                    onChange={handleMemberAccountsChange}
                    label="Member Accounts"
                    size="small"
                    renderValue={(selected) => selected.join(', ')}
                  >
                    {validAccounts.map((account) => (
                      <MenuItem key={account.accountNumber} value={account.accountNumber}>
                        {account.accountName} ({account.accountNumber})
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {errors.memberAccounts}
                    <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', color: 'text.secondary', mt: 0.5 }}>
                      Please make sure you have already created replication role for all the member accounts you want to enable Cloud Event for and they should be linked to this Master Account
                    </Box>
                  </FormHelperText>
                </FormControl>
              ) : null;
            })()}
            
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 3, backgroundColor: "#F98125", "&:hover": { backgroundColor: "#e27021" } }}
              onClick={handleSubmit}
              disabled={props.isPostingFeatureConfiguration}
            >
              Submit
            </Button>
          </Box>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};


const mapStateToProps = (state) => {
  const { 
    isPostingFeatureConfiguration,
    postFeatureConfigurationMessage,
    postFeatureConfigurationError,
  } = state.featureConfiguration;
  return {
    isPostingFeatureConfiguration,
    postFeatureConfigurationMessage,
    postFeatureConfigurationError,    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postFeatureConfiguration: (featureConfigurationPayload) => {
      dispatch(postFeatureConfiguration(featureConfigurationPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BucketPolicyModal);